<template>  
  <v-card flat class="mt-1"> 

    <v-card flat>
      <v-data-table
        v-if="items"
        :headers="headers"
        :items="items"
        hide-default-footer
        :items-per-page="items.length || 10"
        >
        <template v-slot:top>
          <div class="mb-2 pt-2">
            <span class="pr-1 pl-1 caption">Assigning matched name {{targetName}} to</span>
            <person-tipper-click
              :make-person-match="makePersonMatch"
              :target-type="targetType"
              :matching-row="matchingRow"
            >
            </person-tipper-click>
          </div>
        </template>

        <template v-slot:item.action ="{ item }">
          <v-row>
            <v-col cols="3">
              <v-dialog v-model="updateDialog" persistent >
                <template #activator="{ on: dialog }">
                  <v-tooltip
                    right 
                    content-class="caption" 
                    transition="slide-x-transition"
                  >
                    <template #activator="{ on: tooltip }">
                      <v-btn v-on="{ 
                        ...tooltip, 
                        ...dialog 
                        }" icon :disabled="saveInProgress"
                      >
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>edit this role</span>
                  </v-tooltip>
                </template>
               
                <table-person-to-films-dialog
                  :skeleton="item"
                  @save="saveUpdate"
                  @cancel="updateDialog=false"
                >
                </table-person-to-films-dialog>
              
              </v-dialog>
            </v-col>
            <v-col cols="3">
              <v-tooltip
                left 
                color="secondary" 
                content-class="caption" 
                transition="slide-x-transition"
              >
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" @click="deleteRole(item)" :disabled="saveInProgress">
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </template>
                <span>Delete this role</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </template>

        <template  v-slot:no-data>
          No roles in this film currently assigned to {{matchedName}}
        </template>

      </v-data-table>
      <v-card-actions>
        <v-dialog v-model="addDialog" persistent>
          <template #activator="{ on: dialog }">
            <v-tooltip
              right 
              content-class="caption" 
              transition="slide-x-transition"
            >
              <template #activator="{ on: tooltip }">
                <v-btn
                  v-on="{ ...tooltip, ...dialog }"
                    fab
                    bottom
                    left 
                    small
                    color="accent"
                  >
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span class="caption">Assign {{matchedName}} to an additional role</span>
            </v-tooltip>
          </template>

          <table-person-to-films-dialog
            :skeleton="defaultDialog"
            @save="saveInsert"
            @cancel="addDialog=false"
          >
          </table-person-to-films-dialog>

        </v-dialog>
        <v-spacer></v-spacer>
        <v-btn text>
          <span class="caption">Close assignments to {{matchedName}}</span>
          <v-icon :color="closeIconColor" @click="showing">
            {{ closeIcon }}
          </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-card>
</template>
<script>
import { SearchUtils } from '@/js'
import Persontipperclick from '@/components/Persontipperclick'
import Tablepersontofilmsdialog from '@/components/Tablepersontofilmsdialog'
import { FilmToPersonCollection, Controls} from '@/gql'
import { updateFilmToPersonGql, createFilmToPersonGql, removeFilmToPersonGql } from '@/js/mutations'
import { getIconColor, getIcon } from '@/js/store'
import { showToaster, mergeControls } from '@/js/apollo'

export default {
  props: {
    // TODO some of these props can be derived from other props
    // need to clean up and remove
    targetItem: {
      // the target we're looking for a match for
      type: Object,
      required: true
    },
    matchingRow: {
      // the potential match
      type: Object,
      required: true
    },
    targetType: {
      // will always be person for now
      type: String,
      required: true
    },
    filmID: {
      // the id of the film we're assigning to
      type: String,
      required: true
    },
    personID: {
      // the id of the potential person
      type: String,
      required: true
    },
    // this is a small match item with just the person name
    makePersonMatch: {
      type: Object,
      required: true
    },
    // this is the overal reason for the film choice - the filmpage
    reason: {
      type: Object,
      required: true
    }
  },
  components: {
    'table-person-to-films-dialog':Tablepersontofilmsdialog,
    'person-tipper-click': Persontipperclick
  },
  methods: {
    clean (p,action, msg) {

      return Promise.all([p,mergeControls({
        saveInProgress: true
      })])
      .then(()=>{
        showToaster({ 
          header: 'success', 
          type: 'success',
          message: `${action} ${msg}`
        })
        this.updateDialog = false
        this.addDialog = false
        return this.$apollo.queries.FilmToPersonCollection.refetch()
      })
      .then(()=> {
        // signal a refresh back on the film page
        return mergeControls({
          refresh: true
        })
      })
      .catch(err=> {
        showToaster({ 
          header: 'error', 
          type: 'error',
          message: err 
        })
      })
      .finally(()=>mergeControls({
          saveInProgress: false
      }))
    },
    deleteRole (data) {
      const m = `${this.matchedName} as "${this.targetName}:${data.professionName}"`
      if(!confirm(`Are you sure you want to remove ${m} from this film?`)) return

      return this.clean(
          removeFilmToPersonGql({
          apolloClient: this.$apollo,
          id: data.id
        }), 'deleted', m)

    },
    save (data, type) {
      const m = `${this.matchedName} as "${this.targetName}"`
      return this.clean(
        (type === 'create' ? createFilmToPersonGql : updateFilmToPersonGql)({
          apolloClient: this.$apollo,
          data
        }), `${type}d`, m)
    },
    saveInsert (data) {
      return this.save(data,'create')
    },
    saveUpdate (data) {
      return this.save(data,'update')
    },
    showing () {
      this.$emit('showing', null)
    }
  },
  data: () => ({
    addDialog: false,
    updateDialog: false,
    FilmToPersonCollection: null,
    inProgress: false,
    Controls
  }),
  computed: {
    saveInProgress () {
      return this.Controls && this.Controls.saveInProgress
    },
    defaultDialog () {
      return {
        companyName: this.defaultCompany,
        professionName: this.defaultProfession,
        filmID: this.filmID,
        personID: this.personID,
        cameo: false,
        hidden: false,
        freelance: false
      }
    },
    defaultProfession () {
      return this.targetItem && this.targetItem.profession
    },
    defaultCompany () {
      return this.targetItem && this.targetItem.company
    },
    closeIcon () {
      return getIcon('close')
    },
    closeIconColor () {
      return getIconColor('close')
    },
    targetName () {
      return this.targetItem && this.targetItem.person
    },
    matchedName () {
      return this.matchingRow && this.matchingRow.itemName
    },
    headers () {
      return [
        { text: 'Profession', value: 'professionName',sortable:false},
        { text: 'Company Type', value: 'companyTypeName',sortable:false},
        { text: 'Department', value: 'companyDepartmentName',sortable:false},
        { text: 'Company', value: 'companyName',sortable:false },
        { text: 'Actions', value: 'action',sortable:false }
      ]
    },
    items () {
      const items= this.FilmToPersonCollection && 
        this.FilmToPersonCollection.map(f=>SearchUtils.makeTablePersonToFilmItem(f))

      return items
    }
  },

  apollo: {
    Controls: {
      query: Controls
    },
    FilmToPersonCollection: {
      skip() {
        return !this.personID || !this.filmID
      },
      query: FilmToPersonCollection,
      variables () {
        return  {
          limit: 500,
          offset: 0,
          valueKey: "personID",
          value: this.personID,
          filters: [{
            valueKey: "filmID",
            value:this.filmID
          }]
        }
      }
    }
  }
}
</script>
